import React, { FC, ReactNode, useState } from 'react';
import { ChevronDownIcon } from '@app/components/ui/icons/icons-list';
import { headerBoxClassName } from '@app/components/ui/box-spoiler/box-spoiler.style';
import classNames from 'classnames';

type BoxSpoilerProps = {
  title: string | ReactNode;
  children: ReactNode;
  defaultStatus?: boolean;
  sideComponent?: ReactNode;
  ignoreSelectors?: string[];
};

const BoxSpoiler: FC<BoxSpoilerProps> = (props) => {
  const { children, title, defaultStatus = false, sideComponent, ignoreSelectors } = props;
  const [isOpen, changeOpen] = useState<boolean>(defaultStatus);

  const chevronClassName = classNames(
    'transition',
    !isOpen && '-rotate-90',
    'text-3color',
    'mr-[10px]',
  );

  const renderBoxBody = isOpen && <div>{children}</div>;

  function toggleOpenBox(event: React.MouseEvent<HTMLDivElement>) {
    if (ignoreSelectors && ignoreSelectors?.length > 0) {
      const target = event.target as HTMLElement;
      const shouldIgnore = ignoreSelectors?.some((selector) => target.closest(selector));
      if (shouldIgnore) {
        return;
      }
    }
    changeOpen((prevState) => !prevState);
  }

  const renderSideComponent = sideComponent ? <div>{sideComponent}</div> : <></>;

  return (
    <div className="bg-white rounded-[10px] min-h-[62px]">
      <div className={headerBoxClassName({ isOpen })} onClick={toggleOpenBox}>
        <div className="text-0color text-lg font-bold inline-flex items-center w-full">
          <ChevronDownIcon className={chevronClassName} size={12} />
          {title}
        </div>
        <div>{renderSideComponent}</div>
      </div>
      {renderBoxBody}
    </div>
  );
};

export default BoxSpoiler;
